import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IrisIconModule } from '@sondermind/iris/icon';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisButtonModule, IrisButtonTypes } from '@sondermind/iris/button';

import { AppointmentCarouselComponent } from '../appointment-carousel/appointment-carousel.component';
import { ProviderTimeZoneStringPipe } from './provider-timezone-string-pipe/provider-timezone-string.pipe';

@Component({
  selector: 'public-provider-calendar',
  standalone: true,
  imports: [
    CommonModule,
    IrisCardModule,
    IrisButtonModule,
    IrisIconModule,
    AppointmentCarouselComponent,
    ProviderTimeZoneStringPipe,
  ],
  templateUrl: './provider-calendar.component.html',
  styleUrls: ['./provider-calendar.component.scss'],
})
export class ProviderCalendarComponent implements OnInit {
  @Input() providerFirstName: string = '';
  @Input() providerTimeZone: string = '';
  @Input() providerSessionTypesOffered: string[] = [];

  showSessionType: boolean = false;
  irisButtonTypes = IrisButtonTypes;

  ngOnInit(): void {
    this.showSessionType = this.providerSessionTypesOffered.length > 1;
  }
}
